module.exports = __webpack_public_path__ + "img/射箭.085c7343.jpg";